import request from '@/utils/request'

// 查询社区小组帖子媒体列表
export function listCommunityGroupPostMedia(query) {
  return request({
    url: '/biz/admin/community/community/group/post/media/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询社区小组帖子媒体分页
export function pageCommunityGroupPostMedia(query) {
  return request({
    url: '/biz/admin/community/community/group/post/media/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询社区小组帖子媒体详细
export function getCommunityGroupPostMedia(data) {
  return request({
    url: '/biz/admin/community/community/group/post/media/detail',
    method: 'get',
    params: data
  })
}

// 新增社区小组帖子媒体
export function addCommunityGroupPostMedia(data) {
  return request({
    url: '/biz/admin/community/community/group/post/media/add',
    method: 'post',
    data: data
  })
}

// 修改社区小组帖子媒体
export function updateCommunityGroupPostMedia(data) {
  return request({
    url: '/biz/admin/community/community/group/post/media/edit',
    method: 'post',
    data: data
  })
}

// 删除社区小组帖子媒体
export function delCommunityGroupPostMedia(data) {
  return request({
    url: '/biz/admin/community/community/group/post/media/delete',
    method: 'post',
    data: data
  })
}
